'use client';

import { c as _c } from "react/compiler-runtime";
import clsx from 'clsx';
import { ChangeEvent, FC, InputHTMLAttributes } from 'react';
import css from './style.module.scss';
interface Props extends InputHTMLAttributes<HTMLInputElement> {
  value?: string;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  allowedPattern?: RegExp;
  invertColors?: boolean;
}
const Input: FC<Props> = t0 => {
  const $ = _c(15);
  const {
    type: t1,
    placeholder,
    value,
    onChange,
    allowedPattern,
    invertColors,
    name
  } = t0;
  const type = t1 === undefined ? "text" : t1;
  let t2;
  if ($[0] !== allowedPattern || $[1] !== onChange) {
    t2 = e => {
      const inputValue = e.target.value;
      if (allowedPattern && !allowedPattern.test(inputValue)) {
        return;
      }
      onChange?.(e);
    };
    $[0] = allowedPattern;
    $[1] = onChange;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const handleChange = t2;
  const t3 = invertColors && css.invertedColors;
  let t4;
  if ($[3] !== t3) {
    t4 = clsx(css.fieldWrapper, t3);
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== handleChange || $[6] !== name || $[7] !== placeholder || $[8] !== type || $[9] !== value) {
    t5 = <input type={type} placeholder={placeholder} className={css.field} value={value} name={name} onChange={handleChange} />;
    $[5] = handleChange;
    $[6] = name;
    $[7] = placeholder;
    $[8] = type;
    $[9] = value;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <span />;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t4 || $[13] !== t5) {
    t7 = <div className={t4}>{t5}{t6}</div>;
    $[12] = t4;
    $[13] = t5;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
};
export default Input;